import { Navigate } from "react-router-dom";
import { routes } from "../utils";
import {
  AddEditBillingCategory,
  AddEditBlock,
  AddEditCategory,
  AddEditIncidentCategory,
  AddEditIncidentType,
  AddEditInsuranceType,
  AddEditModel,
  AddEditPaymentMethod,
  AddEditPaymentTerm,
  AddEditStateLaw,
  AddTncVariable,
  AddEditZone,
  BillingCategory,
  IncidentCategory,
  IncidentType,
  InsuranceType,
  PaymentMethod,
  PaymentTerm,
  PropertyBlock,
  PropertyCategory,
  PropertyModel,
  PropertyZone,
  StateLaws,
  TncVariable,
  HelpDocument,
  AddEditHelpDocument,
  ManageBOM,
  Employee,
  AddEditEmployee,
  Properties,
  AddEditProperty,
  AddEditBudget,
  AddEditLineItem,
  BudgetMgmt,
  PropertyBulkUpload,
  GLSetup,
  FinancialStatementVersions,
  FinancialVersionBuilder,
  LineItems,
  MasterDataOwners,
  MasterDataOwnerDetails,
  MasterDataCreateOwner,
  MasterDataPropertyOwnership,
  MasterDataOwnershipDetail,
  MasterDataNewOwnership,
  AddEditOwner,
  Announcements,
  OwnerBulkUpload,
  OwnerBulkUploadHistory,
  OwnerBulkUploadDetail,
  VendorMgmt,
  AddEditVendor,
  DocumentTypeConfig,
  AddEditConfig,
  OCPFeeTypes,
  AddEditFeeType,
  OCPDocTypes,
  AddEditOCPDocType,
  OwnershipChangePacket,
  AddEditOCP,
} from "@/pages";
import { TemplatesRoutes } from "./TemplatesRoutes";

export const MasterDataRoutes = () => {
  return {
    path: routes.masterData,
    children: [
      {
        path: "",
        element: (
          <Navigate
            to={`/${routes.admin}/${routes.masterData}/${routes.propertyCategory}`}
          />
        ),
      },
      {
        path: routes.propertyCategory,
        children: [
          {
            path: "",
            element: <PropertyCategory />,
          },
          {
            path: routes.add,
            element: <AddEditCategory />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditCategory />,
          },
        ]
      },
      {
        path: routes.propertyModel,
        children: [
          {
            path: "",
            element: <PropertyModel />,
          },
          {
            path: routes.add,
            element: <AddEditModel />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditModel />,
          },
        ]
      },
      {
        path: routes.propertyZone,
        children: [
          {
            path: "",
            element: <PropertyZone />,
          },
          {
            path: routes.add,
            element: <AddEditZone />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditZone />,
          },
        ]
      },
      {
        path: routes.propertyBlock,
        children: [
          {
            path: "",
            element: <PropertyBlock />,
          },
          {
            path: routes.add,
            element: <AddEditBlock />,
          },
          {
            path: routes.id + "/" + routes.zoneId + "/" + routes.action,
            element: <AddEditBlock />,
          },
        ]
      },
      {
        path: routes.documentTypeConfig,
        children: [
          {
            path: "",
            element: <DocumentTypeConfig />,
          },
          {
            path: routes.add,
            element: <AddEditConfig />,
          },
          {
            path: routes.documentTypeId + "/" + routes.action,
            element: <AddEditConfig />,
          },
        ]
      },
      {
        path: routes.insuranceType,
        children: [
          {
            path: "",
            element: <InsuranceType />,
          },
          {
            path: routes.add,
            element: <AddEditInsuranceType />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditInsuranceType />,
          },
        ]
      },
      {
        path: routes.paymentMethod,
        children: [
          {
            path: "",
            element: <PaymentMethod />,
          },
          {
            path: routes.add,
            element: <AddEditPaymentMethod />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditPaymentMethod />,
          },
        ]
      },
      {
        path: routes.paymentTerm,
        children: [
          {
            path: "",
            element: <PaymentTerm />,
          },
          {
            path: routes.add,
            element: <AddEditPaymentTerm />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditPaymentTerm />,
          },
        ]
      },
      {
        path: routes.billingCategory,
        children: [
          {
            path: "",
            element: <BillingCategory />,
          },
          {
            path: routes.add,
            element: <AddEditBillingCategory />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditBillingCategory />,
          },
        ]
      },
      {
        path: routes.budgetMgmt,
        children: [
          {
            path: "",
            element: <BudgetMgmt />,
          },
          {
            path: routes.add,
            element: <AddEditBudget />,
          },
          {
            path: routes.budgetId + "/" + routes.action,
            element: <AddEditBudget />,
          },
          {
            path: routes.budgetId + "/" + routes.lineItems,
            element: <LineItems />,
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.add,
            element: <AddEditLineItem />,
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.lineItemId +
              "/" +
              routes.action,
            element: <AddEditLineItem />,
          },
        ],
      },
      {
        path: routes.incidentType,
        children: [
          {
            path: "",
            element: <IncidentType />,
          },
          {
            path: routes.add,
            element: <AddEditIncidentType />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditIncidentType />,
          },
        ],
      },
      {
        path: routes.incidentCategory,
        children: [
          {
            path: "",
            element: <IncidentCategory />,
          },
          {
            path: routes.add,
            element: <AddEditIncidentCategory />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditIncidentCategory />,
          },
        ],
      },
      {
        path: routes.tncVariable,
        children: [
          {
            path: "",
            element: <TncVariable />,
          },
          {
            path: routes.add,
            element: <AddTncVariable />,
          },
        ],
      },
      {
        path: routes.stateLaw,
        children: [
          {
            path: "",
            element: <StateLaws />,
          },
          {
            path: routes.add,
            element: <AddEditStateLaw />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditStateLaw />,
          },
        ],
      },
      {
        path: routes.helpDocument,
        children: [
          {
            path: "",
            element: <HelpDocument />,
          },
          {
            path: routes.add,
            element: <AddEditHelpDocument />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditHelpDocument />,
          },
        ]
      },
      TemplatesRoutes(),
      {
        path: routes.manageBOM,
        element: <ManageBOM />
      },
      {
        path: routes.employee,
        children: [
          { path: "", element: <Employee /> },
          { path: routes.add, element: <AddEditEmployee /> },
          {
            path: `${routes.id}`,
            element: <AddEditEmployee />,
          },
        ],
      },
      {
        path: routes.propertyOwnership,
        children: [
          { path: "", element: <MasterDataPropertyOwnership /> },
          { path: routes.newOwnership, element: <MasterDataNewOwnership /> },
          { path: routes.id, element: <MasterDataOwnershipDetail /> },
        ],
      },
      {
        path: routes.owner,
        children: [
          {
            path: routes.createOwner,
            element: <MasterDataCreateOwner />
          },
          {
            path: "",
            element: <MasterDataOwners />
          },
          {
            path: routes.add,
            element: <AddEditOwner />
          },
          {
            path: routes.details + "/" + routes.userId,
            element: <MasterDataOwnerDetails />
          },
          {
            path: routes.userId + "/" + routes.action,
            element: <AddEditOwner />
          },
          {
            path: routes.bulkUpload,
            element: <OwnerBulkUpload />
          },
          {
            path: routes.uploadHistory,
            element: <OwnerBulkUploadHistory />
          },
          {
            path: routes.uploadHistory + "/" + routes.attachmentId,
            element: <OwnerBulkUploadDetail />
          }
        ]
      },
      {
        path: routes.vendorMgmt,
        children: [
          {
            path: "",
            element: <VendorMgmt />
          },
          {
            path: routes.add,
            element: <AddEditVendor />
          },
          {
            path: routes.vendorId + "/" + routes.action,
            element: <AddEditVendor />
          }
        ]
      },
      {
        path: routes.properties,
        children: [
          {path: "", element: <Properties />},
          {path: routes.add, element: <AddEditProperty />},
          {path: routes.propertyId + "/" + routes.action, element: <AddEditProperty />},
          {path: routes.bulkUpload, element: <PropertyBulkUpload />},
        ]
      },
      {
        path: routes.glSetup,
        element: <GLSetup />
      },
      {
        // Admin only: report structures (Category > Subcategory > GL) per community
        path: routes.financialStatementVersions,
        children: [
          { path: "", element: <FinancialStatementVersions /> },
          { path: ":financialTemplateId", element: <FinancialVersionBuilder /> },
        ],
      },
      {
        path: routes.announcement,
        element: <Announcements />
      },
      {
        path: routes.ocpFeeTypes,
        children: [
          {
            path: "",
            element: <OCPFeeTypes />,
          },
          {
            path: routes.add,
            element: <AddEditFeeType />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditFeeType />,
          },
        ]
      },
      {
        path: routes.ocpDocTypes,
        children: [
          {
            path: "",
            element: <OCPDocTypes />,
          },
          {
            path: routes.add,
            element: <AddEditOCPDocType />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AddEditOCPDocType />,
          },
        ]
      },
      {
        path: routes.ownerChangePackage,
        children: [
          {
            path: "",
            element: <OwnershipChangePacket />,
          },
          {
            path: routes.add,
            element: <AddEditOCP />,
          },
          {
            path: `${routes.id}/${routes.action}`,
            element: <AddEditOCP />,
          },
        ],
      },
    ],
  };
};
